import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
import { combineFoodsAndFoodGroupsIntoIndex } from "./utils";
const MealPlanFoodPreferenceContext = createContext({
    isPromotedFood: () => ({
        value: false,
        reason: [],
    }),
    isAvoidedFood: () => ({
        value: false,
        reason: [],
    }),
    promotedFoods: [],
    avoidedFoods: [],
    promotedFoodGroups: [],
    avoidedFoodGroups: [],
});
export const MealPlanFoodPreferenceContextProvider = ({ children, promotedFoods, avoidedFoods, promotedFoodGroups, avoidedFoodGroups, }) => {
    const value = useMemo(() => {
        const promotedFoodsIndex = combineFoodsAndFoodGroupsIntoIndex(promotedFoods, promotedFoodGroups);
        const avoidedFoodsIndex = combineFoodsAndFoodGroupsIntoIndex(avoidedFoods, avoidedFoodGroups);
        return {
            isPromotedFood: (foodId) => {
                const promotedFoodsForFood = [...(promotedFoodsIndex[foodId] || [])];
                return {
                    value: promotedFoodsForFood.length > 0,
                    reason: promotedFoodsForFood.sort(),
                };
            },
            isAvoidedFood: (foodId) => {
                const avoidedFoodsForFood = [...(avoidedFoodsIndex[foodId] || [])];
                return {
                    value: avoidedFoodsForFood.length > 0,
                    reason: avoidedFoodsForFood.sort(),
                };
            },
            promotedFoods,
            avoidedFoods,
            promotedFoodGroups,
            avoidedFoodGroups,
        };
    }, [
        promotedFoods
            .map(f => f.id)
            .sort()
            .join(","),
        avoidedFoods
            .map(f => f.id)
            .sort()
            .join(","),
        promotedFoodGroups
            .map(fg => fg.id)
            .sort()
            .join(","),
        avoidedFoodGroups
            .map(fg => fg.id)
            .sort()
            .join(","),
        promotedFoodGroups
            .flatMap(fg => fg.foods.map(f => f.id))
            .sort()
            .join(","),
        avoidedFoodGroups
            .flatMap(fg => fg.foods.map(f => f.id))
            .sort()
            .join(","),
    ]);
    return _jsx(MealPlanFoodPreferenceContext.Provider, { value: value, children: children });
};
export const useMealPlanFoodPreferenceContext = () => {
    return useContext(MealPlanFoodPreferenceContext);
};
//# sourceMappingURL=MealPlanFoodPreferences.js.map